<div class="agenx-tab">
  <div class="agenx-tab__tabs">
    @for (tab of tabs; track tab.name) {
    <button class="agenx-tab__tab" [ngClass]="{'agenx-tab__tab--active': tab.active}" (click)="selectTab(tab)">
      {{tab.name }}
      @if (tab.exclamation) {
        <!-- <div class="div-excl"><img [src]="iconExcl" class="icon-excl"></div> -->
        <img [src]="iconExcl" class="icon-excl">
      }
      </button>
    } @empty {
    <button class="agenx-tab__tab agenx-tab__tab--active">Default</button>
    }
  </div>
</div>
